export default "__VITE_ASSET__CqkL$S0L__"